import React from 'react'
import PropTypes from 'prop-types'
import { Box, Text } from '@maui/elements'
import { ResponsiveLine } from '@nivo/line'

export const chartColors = [
  '#C74A37',
  '#5F986A',
  '#965AA9',
  '#4A9BBC',
  '#DE8E47',
  '#C24976',
  '#F0DF6D',
  '#73C4AC',
  '#939FB2',
  '#CC00FF',
]

const tooltip = (item) => {
  const { point: { data } } = item
  return (
    <Box>
      <Box
        width='100%'
        display='flex'
        flexDirection='column'
        justifyContent='center'
        alignItems='center'
        background='colorDataVisualizationSequentialRed03'
        color='colorTextMain'
        padding='8px 8px 6px 8px'
        { ...data.first && { marginLeft: '10px' }}
        { ...data.last && { marginRight: '10px' }}
        zIndex='100000'
        gap='4px'
        borderRadius='4px'
      >
        <Text fontWeight='600' fontSize='12px'>{ data.name }</Text>
        <Text fontWeight='400' fontSize='12px'>{ data.xFormatted }</Text>
      </Box>
      <Box
        width='0'
        height='0'
        marginLeft='calc(50% - 10px)'
        borderLeft='10px solid transparent'
        borderRight='10px solid transparent'
        borderTopColor='colorDataVisualizationSequentialRed03'
        borderTopWidth='10px'
        borderTopStyle='solid'
        fontSize='0'
        lineHeight='0'
      ></Box>
    </Box>
  )
}

const commonProperties = {
  axisTop: null,
  axisRight: null,
  axisBottom: {
    orient: 'bottom',
    tickSize: 0,
    tickPadding: 10,
    format: '%-m/%-d/%Y',
    tickValues: 4,
  },
  xScale: {
    type: 'time',
    format: '%-m/%-d/%Y',
    useUTC: false,
    precision: 'day',
  },
  xFormat: 'time:%-m/%-d/%Y',
  axisLeft: null,
  enableGridX: false,
  enableGridY: false,
  height: 45,
  margin: {
    top: 16,
    right: 40,
    bottom: 25,
    left: 40,
  },
  lineWidth: 4,
  onMouseEnter: (data, event) => {
    event.currentTarget.style.cursor = 'pointer'
  },
  pointSize: 12,
  pointBorderWidth: 12,
  padAngle: 1,
  theme: {
    textColor: 'var(--maui-color-text-emphasis)',
    axis: {
      ticks: {
        text: {
          fontSize: 'var(--maui-typography-chart-label-font-size)',
          lineHeight: 16,
          fontWeight: 700,
          letterSpacing: 1.25,
        }
      }
    },
  },
  tooltip: data => tooltip(data),
  useMesh: true,
}

export const LinearLineChart = ({ data: lineData, color, index, onClick, chartProps, displayName, height, width }) => {
  return lineData && (
    <Box height={height} width={width} paddingBottom='10px'>
      { lineData[0]?.name && displayName
        ? <Text
          fontSize='12px'
          color='colorTextEmphasis'
          cursor='pointer'
          onClick={onClick}
        > lineData[0].name</Text>
        : null}
      <ResponsiveLine
        data={lineData}
        {...commonProperties}
        colors={chartColors[index]}
        pointBorderColor={color}
        {...chartProps}
      />
    </Box>
  )
}

LinearLineChart.propTypes = {
  data: PropTypes.array,
  onClick: PropTypes.func,
}

LinearLineChart.defaultProps = {
  data: [],
  onClick: () => {},
  displayName: true,
  height: '80px',
  width: '100%',
}

export default LinearLineChart
